module.exports = __webpack_public_path__ + "img/sign-in.a97aa7dc.svg";